module.exports = "/images/alert-danger.svg?afb3667f7f6701acc8114c35c8b747b1";